import { render, staticRenderFns } from "./MainPress.vue?vue&type=template&id=eb5dd37c"
import script from "./MainPress.vue?vue&type=script&lang=js"
export * from "./MainPress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports